import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Icon from 'shared/components/icon'
import { Spinner } from 'shared/components/spinner'
import { useGetReferralCodeQuery } from 'store/referral-code'

export const ReferAndEarn = () => {
  const navigate = useNavigate()
  const [copied, setCopied] = useState(false)
  const { data, isLoading } = useGetReferralCodeQuery()

  if (!isLoading && !data?.isVisible) return null

  const handleCopy = () => {
    if (!data?.code) return
    navigator.clipboard.writeText(data.code)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className='mx-4 mb-4'>
      <h2 className='font-heading font-medium mb-3'>Refer &amp; Earn</h2>
      <div className='bg-white rounded-xl p-4 shadow-sm border border-border'>
        <p className='text-sm text-gray-500 mb-2'>Your Referral Code</p>

        <button
          type='button'
          onClick={handleCopy}
          disabled={isLoading || !data?.code}
          className='flex flex-row items-center justify-between w-full border-2 border-dashed border-border rounded-lg px-4 py-3 mb-3'
        >
          {isLoading ? (
            <Spinner />
          ) : (
            <span className='text-xl font-semibold tracking-widest'>{data?.code ?? '-'}</span>
          )}
          {copied ? (
            <Icon icon='checkmark-filled' size={20} className='text-green-500' />
          ) : (
            <CopyIcon />
          )}
        </button>

        <div className='flex flex-row items-center gap-2 mb-4 text-sm text-gray-500'>
          <Icon icon='coupon' size={16} className='text-gray-400' />
          <span>{data?.usedCount ?? 0} People used your code</span>
        </div>

        <button
          type='button'
          onClick={() => navigate('/transaction-history')}
          className='flex flex-row items-center justify-between w-full bg-primary rounded-xl px-4 py-3 text-white'
        >
          <div className='text-left'>
            <p className='text-xs opacity-80'>Total Rewards Earned</p>
            <p className='font-semibold text-base'>{data?.rewardDescription} </p>
          </div>
          <Icon icon='arrow-right' size={20} />
        </button>
      </div>
    </div>
  )
}

const CopyIcon = () => (
  <svg
    width={20}
    height={20}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={1.8}
    strokeLinecap='round'
    strokeLinejoin='round'
    className='text-gray-400'
  >
    <rect x='9' y='9' width='13' height='13' rx='2' ry='2' />
    <path d='M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' />
  </svg>
)
